import React, { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { BabylonScene } from './game/BabylonScene';
import { GameOverlay } from './components/GameOverlay';
import { StartScreen } from './components/StartScreen';
import { ColdOpen } from './components/ColdOpen';
import { gameStore, GameState } from './game/store';
export function App() {
  const [state, setState] = useState<GameState>(gameStore.getState());
  useEffect(() => {
    const unsub = gameStore.subscribe(setState);
    return unsub;
  }, []);
  return <div className="relative w-full h-screen overflow-hidden bg-black" data-id="element-0">
      {/* Game canvas — always mounted, so it can run behind cutscenes too */}
      <div className="absolute inset-0 z-10" data-id="element-1">
        <BabylonScene data-id="element-2" />
      </div>

      {/* Playable UI overlay — during 'playing' and 'floor_complete' (for the end screen) */}
      {(state.phase === 'playing' || state.phase === 'floor_complete') && <div className="absolute inset-0 z-20" data-id="element-3">
          <GameOverlay data-id="element-4" />
        </div>}

      {/* Cold open cutscene */}
      <AnimatePresence data-id="element-5">
        {state.phase === 'cold_open' && <ColdOpen data-id="element-6" />}
      </AnimatePresence>

      {/* Start screen */}
      <AnimatePresence data-id="element-7">
        {state.phase === 'start' && <StartScreen data-id="element-8" />}
      </AnimatePresence>

      {/* CRT effect */}
      <div className="crt-overlay" data-id="element-9" />
    </div>;
}